import {h} from 'preact';
import cx from 'classnames';
import PickListItem from '../Item';
import {withPickList} from '../index'

const PickListSelection = ( {pickList, itemRenderer, className = '', interactionClassName = ''} ) => {
    const {itemType, selectedItem, itemIdProp, groupId, isEditing, actions} = pickList;
    const Component = itemRenderer || PickListItem;
    const isEditable = pickList.isEditable();
    const editAction = isEditable ? actions.toggleEditing : () => {};

    return (
        <div data-testid="picklist-selection" className={cx( {hidden: isEditing} )}>
            {selectedItem
                ?
                <div className={cx( className, {[interactionClassName]: isEditable} )}>
                    <Component {...selectedItem} onClick={editAction}/>
                </div>
                :
                <div className={cx( {'button-add-item': isEditable} )} onClick={editAction}>
                    <em className="inline-block">No {itemType} selected</em>
                </div>
            }
            <input id={groupId} name={groupId} type="text"
                   data-testid="picklist-value"
                   className="visually-hidden"
                   value={selectedItem && selectedItem[itemIdProp]}
                   required/>
        </div>
    );
};

export default withPickList( PickListSelection )